import { render } from "./ConfirmLeaveDialog.vue?vue&type=template&id=154c78ec"
import script from "./ConfirmLeaveDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmLeaveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__